import React from "react";
import Search from "../components/Search";

const SearchPage = () => {
    return <Search />;
};

export default SearchPage;
